module.exports = __webpack_public_path__ + "dfb2f19bb958e665945cae3fd6deb289.woff2";